import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Hammer, Mail, CheckCircle, AlertCircle, RefreshCw } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export function VerifyEmailPage() {
  const { user, resendVerification } = useAuth();
  const [email, setEmail] = useState(user?.email ?? '');
  const [isResending, setIsResending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleResend = async () => {
    if (!email.trim()) {
      setError('Introduce tu email');
      return;
    }
    setError('');
    setIsResending(true);
    const result = await resendVerification(email.trim());
    setIsResending(false);
    if (result.success) {
      setDone(true);
    } else {
      setError(result.error || 'No se pudo reenviar la solicitud');
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center space-y-3">
        <Link to="/" className="inline-flex items-center gap-2">
          <span className="w-12 h-12 rounded-xl flex items-center justify-center bg-[var(--b2b-accent)]">
            <Hammer className="w-7 h-7 text-white" />
          </span>
          <span className="text-2xl font-extrabold tracking-tight">ReformAll</span>
        </Link>
      </div>

      <div className="b2b-panel p-8 text-center">
        <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-6 bg-[var(--b2b-surface-muted)]">
          <Mail className="w-8 h-8 text-[color:var(--b2b-accent-strong)]" />
        </div>

        <h1 className="text-2xl font-extrabold tracking-tight mb-2">Pendiente de aprobación</h1>
        <p className="b2b-muted mb-6">
          Tu cuenta está siendo revisada por un administrador. Recibirás un correo cuando esté activada.
        </p>

        {done ? (
          <div className="p-4 bg-[var(--b2b-surface-muted)] rounded-lg border border-[var(--b2b-border)] text-left">
            <p className="text-sm font-semibold mb-1 flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-[color:var(--b2b-success)]" /> Solicitud reenviada
            </p>
            <p className="text-sm b2b-muted">Hemos avisado de nuevo al administrador.</p>
          </div>
        ) : (
          <div className="p-4 bg-[var(--b2b-surface-muted)] rounded-lg border border-[var(--b2b-border)] text-left space-y-3">
            <p className="text-sm font-semibold flex items-center gap-2">
              <AlertCircle className="w-4 h-4" /> ¿Aún esperas?
            </p>
            <p className="text-sm b2b-muted">Puedes avisar de nuevo al administrador con tu email.</p>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="tu@email.com"
              className="w-full rounded-lg border border-[var(--b2b-border)] bg-transparent px-3 py-2 text-sm"
            />
            {error && <p className="text-sm text-[color:var(--b2b-danger)]">{error}</p>}
            <button onClick={handleResend} disabled={isResending} className="b2b-btn b2b-btn--primary w-full justify-center disabled:opacity-60">
              <RefreshCw className={`w-4 h-4 ${isResending ? 'animate-spin' : ''}`} />
              {isResending ? 'Reenviando...' : 'Reenviar solicitud'}
            </button>
          </div>
        )}

        <div className="mt-6 space-y-3">
          <Link to="/login" className="b2b-btn b2b-btn--ghost w-full justify-center">
            Volver al login
          </Link>
        </div>
      </div>
    </div>
  );
}
